"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualPremiumChoiceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var PremiumChoiceComponent_1 = require("../../../components/annual/PremiumChoiceComponent");
var services_1 = require("@falcon/services");
var MonthlyPaymentInfo_1 = require("../common/MonthlyPaymentInfo");
var AnnualPremiumChoiceWidget = /** @class */ (function (_super) {
    __extends(AnnualPremiumChoiceWidget, _super);
    function AnnualPremiumChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            _this.props.onStateChange("factors.premiumType", event.target.value);
            var tieredFactors = _this.props.interaction.tieredFactors;
            if (tieredFactors.length > 0) {
                tieredFactors.forEach(function (factors, index) {
                    _this.props.onStateChange("tieredFactors[".concat(index, "].premiumType"), event.target.value);
                });
            }
        };
        _this.state = {
            bgHeight: 0
        };
        _this.renderQuestions = _this.renderQuestions.bind(_this);
        return _this;
    }
    AnnualPremiumChoiceWidget.prototype.componentDidMount = function () {
    };
    AnnualPremiumChoiceWidget.prototype.render = function () {
        var paymentOption = this.props.interaction.factors ? this.props.interaction.factors.premiumType : undefined;
        var paymentEligibilty = this.props.interaction.polarisPolicyData.instalmentAllowedStatus;
        var monthlyAvailable = paymentEligibilty === "A";
        var instalmentPlanCalculated = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters;
        return (React.createElement("div", { className: "premium-output no-shadow mb-0" },
            React.createElement("div", { className: "top-section" },
                monthlyAvailable && React.createElement(PremiumChoiceComponent_1.PremiumChoiceComponent, { interaction: this.props.interaction, onChange: this.handleOnChangeEvent }),
                !monthlyAvailable && this.renderAnnualOnly(),
                paymentOption === "monthly" && instalmentPlanCalculated && this.renderMonthlyPaymentDetails(),
                monthlyAvailable && this.renderComprehensiveCover()),
            this.renderQuestions()));
    };
    AnnualPremiumChoiceWidget.prototype.renderMonthlyPaymentDetails = function () {
        var annualPrice = this.props.interaction.factors.annualPremium;
        var deposit = this.props.interaction.paymentDetails.instalmentPlan.deposit;
        var numberOfInstalments = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.numberOfInstalments;
        var instalmentPrice = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        var interestRate = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.interestRate;
        var depositPercentage = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.depositPercentage;
        var APR = this.props.interaction.paymentDetails.instalmentPlan.apr;
        var totalAmount = this.props.interaction.paymentDetails.instalmentPlan.totalAmount;
        var creditCost = this.props.interaction.paymentDetails.instalmentPlan.creditCost;
        return (React.createElement(React.Fragment, null,
            this.renderMonthlyPaymentInfo(),
            React.createElement("table", { className: "payment-choice-table mb-3" },
                React.createElement("tr", { className: "payment-choice-row-white" },
                    React.createElement("td", null,
                        "First payment / deposit, ",
                        depositPercentage,
                        "% of the annual price (",
                        (0, commonFunctions_1.getAmountToDisplay)(annualPrice),
                        ")"),
                    React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(deposit))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        numberOfInstalments,
                        " payments of"),
                    React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(instalmentPrice))),
                React.createElement("tr", { className: "payment-choice-row-white" },
                    React.createElement("td", null, "Interest rate"),
                    React.createElement("td", null,
                        interestRate,
                        "%")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Credit representative APR"),
                    React.createElement("td", null,
                        APR,
                        "% *")),
                React.createElement("tr", { className: "payment-choice-row-white" },
                    React.createElement("td", null, "Credit cost"),
                    React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(creditCost))),
                React.createElement("tr", { className: "payment-choice-row-blue" },
                    React.createElement("td", null, "Total amount for 1 year"),
                    React.createElement("td", null,
                        React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(totalAmount)))),
                React.createElement("tr", { className: "payment-choice-row-white clarification-row clarification-row-small" },
                    React.createElement("td", null, "* Credit supplied by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company")))));
    };
    AnnualPremiumChoiceWidget.prototype.renderAnnualOnly = function () {
        return (React.createElement("div", { className: "premium-info text-center" },
            React.createElement("div", { className: "panel" },
                React.createElement("div", { id: "price", className: "price font-family-display font-weight-bold" },
                    (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.annualPremium),
                    React.createElement("span", { className: "muli-bold-16" }, " / year*")),
                React.createElement("p", { className: "font-weight-extra-light" }, "Sorry, we can't offer you a monthly plan"),
                React.createElement("div", { className: "w-100" }),
                React.createElement("p", { className: "font-weight-bold mb-1" },
                    this.getTierUWWording(),
                    services_1.resourcesHelper.UNDERWRITER),
                React.createElement("div", { className: "font-weight-medium" }, "* All figures include Insurance Premium Tax"))));
    };
    AnnualPremiumChoiceWidget.prototype.getTierUWWording = function () {
        return "Comprehensive cover, ";
    };
    AnnualPremiumChoiceWidget.prototype.renderMonthlyPaymentInfo = function () {
        return MonthlyPaymentInfo_1.MonthlyPaymentInfo.renderMonthlyPaymentInfo();
    };
    AnnualPremiumChoiceWidget.prototype.renderComprehensiveCover = function () {
        var premiumType = this.props.interaction.factors.premiumType;
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "d-flex justify-content-center font-weight-bold mb-1" },
                this.getTierUWWording(),
                services_1.resourcesHelper.UNDERWRITER),
            React.createElement("div", { className: "d-flex justify-content-center font-weight-medium" },
                "All figures include ",
                premiumType === services_1.PREMIUM_TYPE_ANNUAL
                    ? 'Insurance Premium Tax'
                    : 'Interest and Insurance Premium Tax')));
    };
    AnnualPremiumChoiceWidget.prototype.renderQuestions = function () {
        return React.createElement(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }));
    };
    return AnnualPremiumChoiceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualPremiumChoiceWidget = AnnualPremiumChoiceWidget;
//# sourceMappingURL=AnnualPremiumChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualPremiumChoiceWidget.js
// module id = 3205
// module chunks = 0